import RA from 'ra-config'

export const CHART_GROUP_MAP = {
  strategies: RA.app.strategies.chartConfig,
  factors: RA.app.factors.chartConfig
}



// WEBPACK FOOTER //
// ./src/config/charts.js